export const getFilteredItems = ({ searchTerm, categories, hideEmptyCategories = false }) => {
  // PosHub menus: hide empty category shells (matches POS console). Native menus unchanged.
  const base = hideEmptyCategories
    ? (categories || []).filter((cat) => (cat.items?.length || 0) > 0)
    : (categories || []);
  const searchTerms = searchTerm?.split(' ').filter((s) => s);
  if (!searchTerm || !searchTerms.length) {
    return base;
  }
  const filteredItems = JSON.parse(JSON.stringify(base)).map((cat) => ({
    ...cat,
    items: cat.items
      .filter(({ name }) => searchTerms.some((term) => name.toLowerCase().includes(term))),
  })).filter((cat) => cat.items.length > 0);

  return filteredItems;
};
